export default __webpack_public_path__ + "static/media/2.4f8109e5.webp";